import hljs from 'highlight.js';
import 'highlight.js/styles/monokai-sublime.css';

if (typeof window !== 'undefined') {
  window.hljs = hljs;
}

export default hljs;
